import { Search, Download } from 'lucide-react'
import type { FilterOptions } from '../types'

interface CallFiltersProps {
  dateFilter: string
  dateFilters: Record<string, string>
  search: string
  onDateFilterChange: (value: string) => void
  onSearchChange: (value: string) => void
  onExport: () => void
}

export function CallFilters({
  dateFilter,
  dateFilters,
  search,
  onDateFilterChange,
  onSearchChange,
  onExport,
}: CallFiltersProps) {
  return (
    <div className="flex items-center justify-between gap-4 mb-4">
      <div className="flex items-center gap-4">
        {/* Date Filter */}
        <select
          value={dateFilter}
          onChange={(e) => onDateFilterChange(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          {Object.entries(dateFilters).map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>

        {/* Search */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search by name or phone..."
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-64"
          />
        </div>
      </div>

      {/* Export Button */}
      <button
        type="button"
        onClick={onExport}
        className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
      >
        <Download className="w-4 h-4" />
        Export CSV
      </button>
    </div>
  )
}
